import {
    postData,
    getData,
    patchData,
    deleteData
} from './Services'


export const getCarritoByUserID = async (user_id, is_login) => {
    const res = await getData(`/carrito/userid?user_id=${user_id}&is_login=${is_login}`)
    return res
}

export const postItemCarrito = async (body) => {
    const res = await postData('/itemscarrito', body, false, "El producto se agrego correctamente")
    return res
}

export const deleteCarritoByID = async (id) => {
    const res = await deleteData(`/itemscarrito/${id}`, false, "El producto se quito correctamente")
    return res
}

export const updateCarritoByID = async (id, body) => {
    const res = await patchData(`/itemscarrito/${id}`, body, false)
    return res
}


export const getCarritoByID = async (id) => {
    const res = await getData(`/carrito/${id}`)
    return res
}

export const buyCarritoByID = async (body) => {
    const res = await postData('/compras', body, true, "La compra se realizo con exito");
    return res
}


